export default {"src":"/_next/static/media/comment.8dd0341f.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};